
/**
 * Modify body
 * Wrap iframe in responsive div wrapper
 * Strip non vimeo or youtube embeds
 * @param {string} body
 */
export const modifyBody = (body) => {
  let newBody = body;
  const reIframe = /(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/g;
  const iframeMatches = body.match(reIframe);

  if (iframeMatches && iframeMatches?.length > 0) {

    iframeMatches.forEach((iframeText) => {
      // Ignore already wrapped iframes!
      if (iframeText.includes('class="ifr"')) {
        return;
      }

      const replacedIframe = iframeText.replace('class="ql-video"', 'class="ql-video ifr" ');
      newBody = newBody.replace(iframeText, `<div class="responsive-wrapper">${replacedIframe}</div>`)
    })
  }

  // Remove empty paragraphs after embeds
  // This is to prevent the issue of extra space after embeds when the content is rendered in the frontend.
  const reEmbedWithSpacer = /(<div class="responsive-wrapper">[\s\S]*?<\/div>|<iframe[^>]*class="[^"]*ql-video[^"]*"[^>]*>(?:[\s\S]*?<\/iframe>)?)((?:\s*<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>)+)/gi;
  newBody = newBody.replace(reEmbedWithSpacer, (match, embed) => embed);

  return newBody;
}


/**
 * Find blocks with body and iframes in them modify the body before submit
 * @param {object} page
 * @returns
 */
export const modifyPage = (page) => {
  const newPage = { ...page };
  newPage.blocks.forEach(block => {
    if (!block.body) return;
    block.body = modifyBody(block.body);
  })

  return newPage;
}